<template>
  <v-dialog
    v-model="dialogFlag"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    scrollable
  >
    <v-container fluid primary>
      <v-dialog persistent v-model="editSettingDialogFlag" width="500">
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title>{{$t("dlgEditSettingsTitle")}}</v-card-title>

          <v-card-text>
            <v-container>
              <v-form ref="editSettingForm" lazy-validation>
                <v-row>
                  <v-col cols="12" class="pa-0 ma-0">
                    <v-select
                      v-model="currentatributtes.resourceTypeId"
                      :label="$t('lblContent')"
                      :items="options_content "
                    ></v-select>
                  </v-col>
                  <v-col
                    class="pa-0 ma-0"
                    cols="12"
                    v-if="currentatributtes.resourceTypeId == 1 || currentatributtes.resourceTypeId == 2   || currentatributtes.resourceTypeId == 9"
                  >
                    <v-file-input
                      show-size
                      
                      :hint="$t('lblResources')"
                      persistent-hint
                      prepend-icon
                      v-model="files"
                      append-icon="mdi-folder-search"
                      v-on:change="handleFileUpload"
                    />
                  </v-col>
                  <v-row v-else>
                    <v-col cols="12" class="pa-0 ma-0 pl-3 pr-3" v-show="currentatributtes.resourceTypeId != 3">
                      <v-text-field
                        v-model="currentatributtes.fileName"
                        :label="$t('lblResources')"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-col cols="12" center v-if="progress > 0">
                    <v-progress-linear v-model="progress" height="25" reactive>
                      <strong>{{ progress }}%</strong>
                    </v-progress-linear>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click.stop="closeEditSettingDialog()">{{$t("btnCancel")}}</v-btn>
            <v-btn text @click.stop="doSettingDialog()" color="primary">{{$t("btnSave")}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-card>
        <v-toolbar dark color="secondary">
          <v-toolbar-title>{{$t('moduleTitle', { menuName: menu.name })}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click.stop="closeDialog()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-data-table
          :loading="isLoading"
          :headers="headers"
          :items="settings"
          class="elevation-1 mt-10"
          color="primary"
        >
          <template v-slot:top>
            <v-toolbar flat color="white">
              <v-spacer></v-spacer>
              <v-btn
                outlined
                color="primary"
                class="ma-2"
                @click.stop="editSettingDialogFlag = true"
              >{{$t('tblbutton')}}</v-btn>
            </v-toolbar>
          </template>
          <!-- PANEL DE ACCIONES -->
          <template v-slot:item.action="{ item }">
            <v-col>
              <v-btn @click.stop="showDeleteDialog(item)" icon class="ml-2" tile>
              <v-icon fab>mdi mdi-delete</v-icon>
            </v-btn>
            </v-col>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
  </v-dialog>
</template>

<script>
import i18nMessages from "./i18n.messages";
import { mapGetters } from "vuex";
//import _ from "lodash";
import uuid from "uuid4";

let BASE_URL_FOR_PHOTOS = "content/menu/resources/";
let DEFAULTF_CURRENT_ATRIBUTE = {
  resourceTypeId: 2,
  SecondResourceTypeId: 0,
  fileName: "",
};
let DEFAULT_FILE_MODEL = { isValid: false, contentData: null };
export default {
  props: {
    settings: {
      type: Array,
      required: true,
    },
    isnivel3:{
      type:Boolean,
      required:false,
    },
    menuId: {
      type: Number,
      required: true,
    },

    menu: {
      type: Object,
      required: true,
    },

    dialogFlag: {
      type: Boolean,
      required: true,
    },
  },
  created() {
    this.$i18n.locale = this.locale;
    this.updateHeadersLocale();
  },
  beforeDestroy() {},
  i18n: i18nMessages,
  data: function () {
    return {
      errorMessage: "",
      currentatributtes: DEFAULTF_CURRENT_ATRIBUTE,
      editSettingDialogFlag: false,
      currentFile: DEFAULT_FILE_MODEL,
      // archivos
      files: [],
      progress: 0,
      headers: [
        {
          id: "headerResource",
          text: "Recurso",
          sortable: false,
          value: "content",
        },
        {
          id: "headerType",
          text: "Tipo de recurso",
          value: "resourceTypeId",
          sortable: false,
        },
        {
          id: "headerAction",
          text: "Acciones",
          value: "action",
          sortable: false,
        },
      ],
      options_content: [
        { value: 1, text: "PDF" },
        { value: 2, text: "IMAGE (Estática, PNG, JPG, GIF)" },
        { value: 3, text: "Submenu" },
        { value: 4, text: "URL (Externa)" },
        { value: 5, text: "VIDEO (Youtube) " },
        { value: 6, text: "VIDEO (Facebook) " },
        { value: 7, text: "VIDEO (Vimeo) " },
        {
          value: 8,
          text: "VIDEO (URL, se abré en un webview embebido en la app)",
        },
        { value: 9, text: "Mapa (PNG) " },
        { value: 10, text: "Timeline Fav " },
        { value: 11, text: "Timeline" },
        { value: 12, text: "Timeline + Fav " },
        { value: 13, text: "Toolbox " },
        { value: 14, text: "Favoritos" },
        { value: 15, text: "URL Embebida (webview) " },
        { value: 16, text: "LikendIn " },
        { value: 17, text: "Facebook " },
        { value: 18, text: "Instagram" },
        { value: 19, text: "Twitter" },
        { value: 20, text: "YouTube Channel" },
        { value: 99, text: "HTML" },
        { value: 100, text: "Nativa" },
        { value: 101, text: "iOS/StoryBoard" },
        { value: 102, text: "iOS/Controller" },
        { value: 103, text: "Android/Activity" },
        { value: 104, text:"IdParam" },
        { value: 127, text: "IDNATIVE" },
        { value: 126, text: "LINK" },
      ],
      options_content2: [
        {value: 10, text:"Timeline Fav " },
        {value: 13, text:"Toolbox " },
        {value: 14, text:"Favoritos" },
      ],
    };
  },
  mounted: () => {},
  computed: {
    ...mapGetters(["isLoading"]),
    locale() {
      return this.$store.getters["locale"];
    },
  },
  watch: {
    locale(value) {
      this.$i18n.locale = value;
      this.updateHeadersLocale();
    },
  },
  methods: {
    // Actualiza el idioma de los encabezados de la tabla
    updateHeadersLocale() {
      this.headers = this.headers.map((header) => {
        header.text = this.$t(header.id);
        return header;
      });
    },
    closeDialog() {
      this.$emit("closeResourceDialogEvent");
      this.errorMessage = "";
    },
    closeEditSettingDialog() {
      this.editSettingDialogFlag = false;
      this.currentFile = {};
      this.currentatributtes = {};
      this.progress = 0;
      this.files = [];
    },
    reloadResource() {
      let data = {
        itemId: this.menuId,
      };
      console.log("/api/screenSettings/resources/{{itemId}}", data);
      return this.$GET("/api/screenSettings/resources/{{itemId}}", data)
        .then((resource) => {
          this.settings = resource.resources;
          return this.resource;
          //console.log(menu);
        })
        .catch(() => {
          //** console.log(e)
        });
    },
    doSettingDialog() {
      if (this.currentatributtes.resourceTypeId == 1 || this.currentatributtes.resourceTypeId == 2 || this.currentatributtes.resourceTypeId == 9) {
        this.doUploadPhoto((path) => {
          console.log("=================== PATH ======================");
          console.log("path", path);
          console.log("=================== ++++ ======================");
          //this.currentatributtes.fileName = path.replace("content/", "");
          let payload = {
            data: {
              type: this.currentatributtes.resourceTypeId,
              content: path.replace("content/", ""),
              optionId: this.menuId,
            },
          };
          console.log("/api/screenSettings/setResources", payload);
          this.$POST("/api/screenSettings/setResources", payload)
            .then(() => {
              this.closeEditSettingDialog();
              this.reloadResource();
            })
            .catch((e) => {
              console.log("error con endpint", e);
            })
            .finally(() => {
              this.closeEditSettingDialog();
            });
        });
        
      } else {
        let payload = {
          data: {
            type:this.currentatributtes.resourceTypeId ,
            content: this.currentatributtes.fileName,
            optionId: this.menuId,
          },
        };
        console.log("/api/screenSettings/setResources", payload);
        this.$POST("/api/screenSettings/setResources", payload)
          .then(() => {
            this.closeEditSettingDialog();
            this.reloadResource();
          })
          .catch((e) => {
            console.log("error con endpint", e);
          })
          .finally(() => {
            this.closeEditSettingDialog();
          });
      }
    },
    // Manejador del archivo
    handleFileUpload(currentFile) {
      let self = this;
      if (!currentFile || currentFile.length === 0) {
        this.currentFile = null;
      } else {
        self.$store.dispatch("initLoader");
        self.currentFile = currentFile;
        self.currentFile.isValid = false;
        self.currentFile.contentData = null;
        self.errorMessage = "";
        let format = self.currentFile.type.split("/");
        let reader = new FileReader();
        reader.onload = function (e) {
          try {
            let data = new Uint8Array(e.target.result);
            self.currentFile.contentData = data;
            self.currentFile.isValid = true;
            self.currentFile.format = format[1];
          } catch (error) {
            window.self.errorMessage = error.message; //** console.log(error);
          } finally {
            self.$store.dispatch("stopLoader");
          }
        };
        reader.readAsArrayBuffer(self.currentFile);
        console.log("currentFile", self.currentFile);
      }
    },
    // Carga el archivo en el bucket S3
    async doUploadPhoto(callback) {
      this.totalSteps = 0;
      this.completedSteps = 0;

      if (this.currentFile.isValid && this.currentFile.contentData) {
        let path = `${BASE_URL_FOR_PHOTOS}${uuid()}.${this.currentFile.format}`;
        console.log("Content id:" + path);
        return this.$Storage
          .put(
            path,
            this.currentFile.contentData,
            this.uploadProgressCallback,
            () => {
              return callback(path);
            }
          )
          .then(() => {
            console.log("archivo subido con exito a s3");
          })
          .catch(() => {
            console.log("error al subir archivo  a s3");
          });
      } else {
        throw new Error("Invalid file");
      }
    },
    // Progess callback
    uploadProgressCallback(progress) {
      this.progress = Math.ceil((progress.loaded / progress.total) * 100);
      /* console.log(
        `Uploaded: ${progress.loaded}/${progress.total}  ${this.progress}%`
      );*/
    },
    showDeleteDialog(item){
      let payload = {
        data: {
          resourceId: item.id,
          optionId: this.menuId,
        }
      };
      
      this.$POST("/api/resource/delete", payload)
        .then( () => {
          //** console.log(response);
          this.reloadResource();
        })
        .catch(() => {
          //** console.log(e);
         
        })
        .finally(() => {});
    }
  },
};
</script>